import { Outlet } from "react-router-dom";

export const BlogsOutlet = () => {
  return <Outlet />;
};
